import React, { useState, useEffect } from 'react';
import api from '../BaseURL/BaseURL';
import { useAuth } from '../Contexts/AuthContext';

const AddItem = ({ addItem }) => {
  const [mealTypes, setMealTypes] = useState([]);
  const [foodTypes, setFoodTypes] = useState([]);
  const [sources, setSources] = useState([]);
  const [reasons, setReasons] = useState([]);

  const { token } = useAuth();
  const [formData, setFormData] = useState({
    meal_type: '',
    source: '',
    reason: '',
    food_type: '',
    food_description: '',
    is_edible: '',
    empty_weight: '',
    total_weight: '',
    employee_name: '',
    shift: '',
    waste_date: '',
    day: '',
  });
  const [popupVisible, setPopupVisible] = useState(false);

  useEffect(() => {
    const fetchMealTypes = async () => {
      try {
        const response = await api.get('/employee/meal-types', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200 && response.data.status) {
          setMealTypes(response.data.data); // Store meal types
        }
      } catch (error) {
        console.error('Error fetching meal types:', error);
      }
    };
  
    fetchMealTypes();
  }, [token]); // Runs once when component mounts
  
  useEffect(() => {
    const fetchFoodTypes = async () => {
      try {
        const response = await api.get('/employee/food-types', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200 && response.data.status) {
          setFoodTypes(response.data.data); // Store food types
        }
      } catch (error) {
        console.error('Error fetching food types:', error);
      }
    };
  
    fetchFoodTypes();
  }, [token]); // Runs once when component mounts
  
  useEffect(() => {
    const fetchSources = async () => {
      try {
        const response = await api.get('/employee/sources', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200 && response.data.status) {
          setSources(response.data.data); // Store sources
        }
      } catch (error) {
        console.error('Error fetching sources:', error);
      }
    };
  
    fetchSources();
  }, [token]); // Runs once when component mounts

  useEffect(() => {
    const fetchReasons = async () => {
      try {
        const response = await api.get('/employee/reasons', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200 && response.data.status) {
          setReasons(response.data.data); // Store reasons
        }
      } catch (error) {
        console.error('Error fetching reasons:', error);
      }
    };
  
    fetchReasons();
  }, [token]); // Runs once when component mounts
  
  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (e, list, key, idKey) => {
    const selectedItem = list.find(item => item.name === e.target.value);
    setFormData({
      ...formData,
      [key]: selectedItem ? selectedItem.name : '',
      [idKey]: selectedItem ? selectedItem.id : '',  // Store ID separately
    });
  };
  

  

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const selectedMealType = mealTypes.find(meal => meal.name === formData.meal_type);
    const selectedFoodType = foodTypes.find(food => food.name === formData.food_type);
    const selectedFoodDescription = selectedFoodType?.food_descriptions?.find(desc => desc.name === formData.food_description);
    const selectedSource = sources.find(source => source.name === formData.source);
    const selectedReason = reasons.find(reason => reason.name === formData.reason);
  
    const newItem = {
      meal_type_id: selectedMealType ? selectedMealType.id : '',  
      meal_type: selectedMealType ? selectedMealType.name : '',
  
      food_type_id: selectedFoodType ? selectedFoodType.id : '',
      food_type: selectedFoodType ? selectedFoodType.name : '',
  
      food_description_id: selectedFoodDescription ? selectedFoodDescription.id : '',
      food_description: selectedFoodDescription ? selectedFoodDescription.name : '',
  
      source_id: selectedSource ? selectedSource.id : '',
      source: selectedSource ? selectedSource.name : '',
  
      reason_id: selectedReason ? selectedReason.id : '',
      reason: selectedReason ? selectedReason.name : '',
  
      is_edible: formData.is_edible === 'صالح',
      empty_weight: parseFloat(formData.empty_weight),
      total_weight: parseFloat(formData.total_weight),
      employee_name: formData.employee_name,
      shift: formData.shift,
      waste_date: formData.waste_date,
      day: formData.day,
    };
  
    const existingItems = JSON.parse(localStorage.getItem('items')) || [];
    const updatedItems = [...existingItems, newItem];
  
    localStorage.setItem('items', JSON.stringify(updatedItems));
    addItem(newItem);
  
    setFormData({
      meal_type: '',
      meal_type_id: '',  
      food_type: '',
      food_type_id: '',
      food_description: '',
      food_description_id: '',
      source: '',
      source_id: '',
      reason: '',
      reason_id: '',
      is_edible: '',
      empty_weight: '',
      total_weight: '',
      employee_name: '',
      shift: '',
      waste_date: '',
      day: '',
    });
  
    setPopupVisible(true);
  };
  
  


  const closePopup = () => {
    setPopupVisible(false); // Hide the popup
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl text-right font-semibold text-gray-700 mb-6">إضافة عنصر</h1>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Row 1 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
  <label htmlFor="food_type" className="block text-sm text-right font-medium text-gray-700 mb-2">
    نوع الغذاء
  </label>
  <select
    id="food_type"
    name="food_type"
    value={formData.food_type}
    onChange={(e) => handleSelectChange(e, foodTypes, 'food_type', 'food_type_id')}
    className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
    ${formData.food_type === '' ? 'text-gray-400' : 'text-black'}`}
    required
  >
    <option value="">اختر نوع الغذاء</option>
    {foodTypes.map((food) => (
      <option key={food.id} value={food.name}>
        {food.name}
      </option>
    ))}
  </select>
</div>

<div>
  <label htmlFor="reason" className="block text-sm text-right font-medium text-gray-700 mb-2">
    السبب
  </label>
  <select
    id="reason"
    name="reason"
    value={formData.reason}
    onChange={(e) => handleSelectChange(e, reasons, 'reason', 'reason_id')}
    className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
      ${formData.reason === '' ? 'text-gray-400' : 'text-black'}`}
    required
  >
    <option value="">اختر السبب</option>
    {reasons.map((reason) => (
      <option key={reason.id} value={reason.name}>
        {reason.name}
      </option>
    ))}
  </select>
</div>



          <div>
  <label htmlFor="source" className="block text-sm text-right font-medium text-gray-700 mb-2">
    المصدر
  </label>
  <select
    id="source"
    name="source"
    value={formData.source}
    onChange={(e) => handleSelectChange(e, sources, 'source', 'source_id')}
    className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
    ${formData.source === '' ? 'text-gray-400' : 'text-black'}`}
    required
  >
    <option value="">اختر المصدر</option>
    {sources.map((source) => (
      <option key={source.id} value={source.name}>
        {source.name}
      </option>
    ))}
  </select>
</div>

          <div>
             <label htmlFor="meal_type" className="block text-sm text-right font-medium text-gray-700 mb-2">
               نوع الوجبة
             </label>
             <select
               id="meal_type"
               name="meal_type"
               value={formData.meal_type}
               onChange={(e) => handleSelectChange(e, mealTypes, 'meal_type', 'meal_type_id')}
               className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
               ${formData.meal_type === '' ? 'text-gray-400' : 'text-black'}`}
               required
             >
               <option value="">اختر نوع الوجبة</option>
               {mealTypes.map((meal) => (
                 <option key={meal.id} value={meal.name} >
                   {meal.name}
                 </option>
               ))}
             </select>
          </div>

          
          
          
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
            <label htmlFor="total_weight" className="block text-sm text-right font-medium text-gray-700 mb-2">
            اجمالي الوزن (غرام)
            </label>
            <input
              type="number"
              id="total_weight"
              name="total_weight"
              value={formData.total_weight}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل اجمالي الوزن"
              required
            />
          </div>
          <div>
            <label htmlFor="empty_weight" className="block text-sm text-right font-medium text-gray-700 mb-2">
            الوزن الفارغ (غرام)
            </label>
            <input
              type="number"
              id="empty_weight"
              name="empty_weight"
              value={formData.empty_weight}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل الوزن الفارغ"
              required
            />
          </div>
          <div>
            <label htmlFor="is_edible" className="block text-sm text-right font-medium text-gray-700 mb-2">
              صالح/غير صالح
            </label>
            <select
              id="is_edible"
              name="is_edible"
              value={formData.is_edible}
              onChange={handleChange}
              className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
      ${formData.is_edible === '' ? 'text-gray-400' : 'text-black'}`}
              required
            >
              <option value="">اختر</option>
              <option value="صالح">صالح</option>
              <option value="غير صالح">غير صالح</option>
            </select>
          </div>
          <div>
  <label htmlFor="food_description" className="block text-sm text-right font-medium text-gray-700 mb-2">
    وصف الغذاء
  </label>
  <select
    id="food_description"
    name="food_description"
    value={formData.food_description}
    onChange={(e) => handleSelectChange(e, foodTypes.find(f => f.name === formData.food_type)?.food_descriptions || [], 'food_description', 'food_description_id')}
    className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
    ${formData.food_description === '' ? 'text-gray-400' : 'text-black'}`}
    required
  >
    <option value="">اختر وصف الغذاء</option>
    {foodTypes
      .find((food) => food.name === formData.food_type)?.food_descriptions
      ?.map((desc) => (
        <option key={desc.id} value={desc.name}>
          {desc.name}
        </option>
      ))}
  </select>
</div>
         
          
      
        </div>

        {/* Row 3 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
            <label htmlFor="waste_date" className="block text-sm text-right font-medium text-gray-700 mb-2">
              التاريخ
            </label>
            <input
              type="date"
              id="waste_date"
              name="waste_date"
              value={formData.waste_date}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border text-gray-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              required
            />
          </div>
          <div>
  <label htmlFor="day" className="block text-sm text-right font-medium text-gray-700 mb-2">
    اليوم
  </label>
  <select
    id="day"
    name="day"
    value={formData.day}
    onChange={handleChange}
    className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
    ${formData.day === '' ? 'text-gray-400' : 'text-black'}`}
    required
  >
    <option value="">اختر اليوم</option>
    <option value="الأحد">الأحد</option>
    <option value="الاثنين">الاثنين</option>
    <option value="الثلاثاء">الثلاثاء</option>
    <option value="الأربعاء">الأربعاء</option>
    <option value="الخميس">الخميس</option>
    <option value="الجمعة">الجمعة</option>
    <option value="السبت">السبت</option>
  </select>
</div>

          
          <div>
  <label htmlFor="shift" className="block text-sm text-right font-medium text-gray-700 mb-2">
    الوردية
  </label>
  <select
    id="shift"
    name="shift"
    value={formData.shift}
    onChange={handleChange}
    className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
    ${formData.shift === '' ? 'text-gray-400' : 'text-black'}`}
    required
  >
    <option value="">اختر الوردية</option>
    <option value="A">A</option>
    <option value="B">B</option>
    <option value="C">C</option>
  </select>
</div>

          <div>
            <label htmlFor="employee_name" className="block text-sm text-right font-medium text-gray-700 mb-2">
              اسم الموظف
            </label>
            <input
              type="text"
              id="employee_name"
              name="employee_name"
              value={formData.employee_name}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل اسم الموظف"
              required
            />
          </div>
         
         
         
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className=" bg-[#DD5B35] text-white py-2 px-4 rounded-lg hover:bg-[#F4A68D] hover:text-black"
        >
          إضافة عنصر
        </button>
      </form>
      {popupVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <h2 className="text-lg font-semibold mb-4">تمت إضافة العنصر بنجاح</h2>
            <button
              onClick={closePopup}
              className="bg-[#DD5B35] text-white py-2 px-4 rounded-lg hover:bg-[#F4A68D] hover:text-black focus:outline-none"
            >
              إغلاق
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddItem;
